import { useContext, useState } from 'react';
import { LocationContext } from '../../../../shared/Context';
import SearchLocation from './SearchLocation/SearchLocation';

function SidebarActions() {
  const { locationData } = useContext(LocationContext);
  const [open, setOpen] = useState(false);

  function formatAddress() {
    const { address, city, region, postal } = locationData;

    return (
      <>
        {address ? (
          <>
            {address}
            <br />
          </>
        ) : null}
        {city ? `${city}, ` : null} {region ? `${region} ` : null}&nbsp;
        {postal ? `${postal} ` : null}
      </>
    );
  }

  return (
    <>
      <div className="border-black/10 border-b bg-white/90 px-8 py-4">
        <h2 className="font-bold text-4xl">Find A Partner</h2>
        <div className="my-2 w-1/3 border-2 border-rcprimary-400 border-b" />
        <p className="mb-4 text-sm">
          Retainer Club partners with orthodontists and dentists across the
          country to provide the most advanced 3D scans of your teeth. Enter
          your location to find an office near you.
        </p>
        <div>
          <div className="flex flex-row items-center justify-between">
            <div>
              <p className="block font-medium text-black/70 text-sm capitalize leading-6">
                Current Location
              </p>
              <p className="font-bold text-rcprimary-400 text-sm">
                {formatAddress()}
              </p>
            </div>

            <button
              type="button"
              onClick={() => setOpen(true)}
              className="flex flex-row items-center rounded-md bg-rcprimary-400 px-2.5 py-1 font-medium text-black text-xs shadow-md ring-1 ring-transparent ring-inset hover:bg-transparent hover:text-rcprimary-400 hover:ring-rcprimary-400"
            >
              Update Location
            </button>
          </div>
        </div>
        {/*
          <div className="flex flex-row gap-x-4 ">
            <SearchFilter totalObjects={totalObjects} />
          </div>
        */}
      </div>
      <SearchLocation open={open} setOpen={setOpen} />
    </>
  );
}

export default SidebarActions;
